// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifications_container__2KN1D"};